import { ShowCustomDataAction } from '@app/modules/audit/components/ShowCustomDataAction';
import { getSpotVerifyMatchTargetFromSchedule } from '@app/modules/audit/modules/station-audit/components/verify-match/to-verify-match-target';
import { useVerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/useVerifyMatchListDialog';
import { VerifyMatchAction } from '@app/modules/audit/modules/station-audit/components/verify-match/VerifyMatchAction';
import { VerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/VerifyMatchListDialog';
import { AuditSchedule } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { RowActionMui } from '../../../../../../../../components/table/RowActionMui';
import { RowActions } from '../../../../../../../../components/table/RowActions';
import { ListingResultProps } from '../../../../../../../../core/reports/components/ListingView';
import { useActiveStation } from '../../../../../../../../core/stations/hooks/useActiveStation';
import { AuditMediaPlayerAction } from '../../../../components/AuditMediaPlayerAction';
import { NoAudioIndicator } from '../../../../components/schedule/NoAudioIndicator';
import { ScheduleMatchStatus } from '../../../../components/schedule/ScheduleMatchStatus';
import { useSchedulesListColumns } from '../../useSchedulesListColumns';
import { SchedulesSpotListing } from './SchedulesSpotListView';

/**
 * Spot schedules table with verify-match dialog navigation.
 */
export function SchedulesListSpotResult(p: ListingResultProps<SchedulesSpotListing>) {
  const station = useActiveStation();
  const { openAt, onDisplayRowsChange, dialogProps } = useVerifyMatchListDialog(
    getSpotVerifyMatchTargetFromSchedule,
  );

  const viewScheduleUrlFn = (schedule: AuditSchedule) =>
    `/audit/s/${station.slug}/schedule/spot/${schedule.id}`;

  const columns = useSchedulesListColumns({
    actionsColumnSize: 150,
    statusCell: ({ row }) => {
      if (!row.original.audio) {
        return <NoAudioIndicator />;
      }

      return <ScheduleMatchStatus schedule={row.original} />;
    },
    actionsCell: ({ row }) => {
      const schedule = row.original;
      const verifyTarget = getSpotVerifyMatchTargetFromSchedule(schedule);

      return (
        <RowActions>
          {verifyTarget && <VerifyMatchAction onClick={() => openAt(verifyTarget)} />}

          <RowActionMui
            title={
              <FormattedMessage
                id="audit.schedulesListScreen.viewScheduleBtn"
                defaultMessage="Ver detalle"
              />
            }
            link={viewScheduleUrlFn(schedule)}
          >
            <OpenInNewIcon />
          </RowActionMui>

          {schedule.audio && !verifyTarget && (
            <AuditMediaPlayerAction
              audio={{
                ...schedule.audio,
                stationId: station.id,
              }}
            />
          )}

          <ShowCustomDataAction customId={schedule.customId} customData={schedule.custom} />
        </RowActions>
      );
    },
  });

  return (
    <>
      <MrtTable
        {...p.mrtProps}
        enableTopToolbar={false}
        onDisplayRowsChange={onDisplayRowsChange}
        columns={columns}
      />
      <VerifyMatchListDialog dialogProps={dialogProps} />
    </>
  );
}
